const toggleBemModifier = (core, modifier, withModifier) => `${core}${withModifier ? ` ${core}_${modifier}` : ''}`;

export default toggleBemModifier;
